import React from "react";

const SELOS = [
  { ic: "/icons/selos/mini_sem_anuncios.png", h: "Sem anúncios", p: "Nenhuma propaganda durante a diversão." },
  { ic: "/icons/selos/mini_100_infantil.png", h: "Ambiente 100% infantil", p: "Tudo pensado para os pequeninos." },
  { ic: "/icons/selos/mini_conteudo_seguro.png", h: "Conteúdo seguro", p: "Valores que fortalecem a fé." },
  { ic: "/icons/selos/mini_em_qualquer_tela.png", h: "Em qualquer tela", p: "TV, celular e tablet." },
];

// Os 4 selos da página inicial nova (sem anúncios, 100% infantil...), usados também na /tv.
export default function Selos() {
  return (
    <div className="wrap">
      <div className="selos">
        {SELOS.map((s) => (
          <div className="selo" key={s.h}>
            <div className="ic"><img src={s.ic} alt="" /></div>
            <h3>{s.h}</h3><p>{s.p}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
